<template>
  <a-modal
    ref="createModal"
    title="新增单位"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ y: 250 }"
    >
      <!-- 单位 -->
      <span slot="unitOfMeasureTitle">
        <i class="toRequired">*</i>单位
      </span>
      <template slot="unitOfMeasure" slot-scope="text, record">
        <a-input v-model="record.unitOfMeasure" />
      </template>

      <template slot="unitDesc" slot-scope="text, record">
        <a-input v-model="record.unitDesc" />
      </template>
      <!-- 分类 -->
      <span slot="uomClassTitle">
        <i class="toRequired">*</i>分类
      </span>
      <template slot="uomClass" slot-scope="text, record">
        <a-select show-search option-filter-prop="children" v-model="record.uomClass">
          <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </template>
      <!-- 基本单位 -->
      <span slot="baseUomFlagTitle">
        <i class="toRequired">*</i>基本单位
      </span>
      <template slot="baseUomFlag" slot-scope="text, record">
        <a-select v-model="record.baseUomFlag">
          <a-select-option v-for="(item) in baseUomFlagOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
        </a-select>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiMdmUomUnitsOfMeasureAdd } from '@/api/mdm/units/unit'
// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '单位',
          width: 150,
          dataIndex: 'unitOfMeasure',
          scopedSlots: { customRender: 'unitOfMeasure', title: "unitOfMeasureTitle" }
        },
        {
          title: '说明',
          width: 150,
          dataIndex: 'unitDesc',
          scopedSlots: { customRender: 'unitDesc' }
        },
        {
          // title: '分类',
          width: 150,
          dataIndex: 'uomClass',
          scopedSlots: { customRender: 'uomClass', title: "uomClassTitle" }
        },
        {
          // title: '基本单位',
          width: 150,
          dataIndex: 'baseUomFlag',
          scopedSlots: { customRender: 'baseUomFlag', title: "baseUomFlagTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: []
    }
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        unitOfMeasure: "",
        unitDesc: "",
        uomClass: "",
        baseUomFlag: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].unitOfMeasure || !this.typeList[i].uomClass || !this.typeList[i].baseUomFlag) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiMdmUomUnitsOfMeasureAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
